var map = {
	"./1-10_icon.svg": 777,
	"./10-10_icon.svg": 778,
	"./2-10_icon.svg": 779,
	"./3-10_icon.svg": 780,
	"./4-10_icon.svg": 781,
	"./5-10_icon.svg": 782,
	"./6-10_icon.svg": 783,
	"./7-10_icon.svg": 784,
	"./8-10_icon.svg": 785,
	"./9-10_icon.svg": 786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 274;